import PropTypes from 'prop-types'
import React, { Component } from 'react'

import BasePage from '../../base/components/BasePage'

export default class AuthBase extends Component {
  render() {
    return (
      <BasePage>
        {this.props.children}
      </BasePage>
    )
  }
}

AuthBase.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
}



// WEBPACK FOOTER //
// ./src/auth/components/AuthBase.js